module.exports = __webpack_public_path__ + "img/SketchPng957dd1dc6eddd674b0817d79707b8ebba9c1e962c1170837444e7843d4f9a593.7662aa22.png";